import Vue from "vue";

import VModal from "vue-js-modal";
Vue.use(VModal);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBellSlash,
  faPlusCircle,
  faCheckCircle,
  faArrowLeft,
  faArrowRight,
  faHeart,
  faEllipsisV,
  faShareSquare,
  faBell,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faBellSlash,
  faPlusCircle,
  faCheckCircle,
  faArrowLeft,
  faArrowRight,
  faHeart,
  faEllipsisV,
  faShareSquare,
  faBell,
  faExternalLinkAlt
);

import { faSpotify } from "@fortawesome/free-brands-svg-icons/faSpotify";
library.add(faSpotify);

import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
library.add(farHeart);

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

// Infinite Loading
import InfiniteLoading from "vue-infinite-loading";
Vue.use(InfiniteLoading, {});

// Toggle
import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);

Vue.use(require("vue-moment"));

// Toast
import Toast from "vue-easy-toast";
Vue.use(Toast);

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

import VueMatomo from "vue-matomo";

Vue.mixin({
  methods: {
    //https://matomo.org/faq/reports/the-anatomy-of-an-event/
    trackEvent: function (category, action, name, value) {
      const userId = this.$store.getters["auth/getUserId"];
      if (this.$matomo != null) {
        if (userId) {
          this.$matomo.setUserId(userId);
        }
        this.$matomo.trackEvent(category, action, name, value);
      }
    },
    openMenu: function () {
      this.$store.dispatch("menu/openMenu");
    },
    closeMenu: function () {
      this.$store.dispatch("menu/closeMenu");
    },
    isLoading() {
      return this.$store.getters["loading/isLoading"];
    },
    toast(text) {
      Vue.toast(text, {
        duration: 3000,
        mode: "override",
        closeable: false,
        horizontalPosition: "center",
        verticalPosition: "bottom",
        defaultTransition: "fade",
        defaultClass: "",
      });
    },
  },
});

router.beforeEach(function (to, from, next) {
  const isLoggedIn = store.getters["auth/isLoggedIn"];

  // Save scroll state for feed & shops page
  // if (from.name == "Feed") {
  //   const appcontainer = document.getElementById("app-container");
  //   if (appcontainer) {
  //     store.commit("saveFeedScroll", appcontainer.scrollTop);
  //   }
  // }
  // if (from.name == "Shop") {
  //   const appcontainer = document.getElementById("app-container");
  //   if (appcontainer) {
  //     store.commit("saveShopScroll", appcontainer.scrollTop);
  //     store.commit("saveLastShop", from.params["shopId"]);
  //   }
  // }
  // if (from.name == "List") {
  //   // const appcontainer = document.getElementById("app-container");
  //   const appcontainer = document.getElementById("main");
  //   if (appcontainer) {
  //     store.commit("saveListScroll", appcontainer.scrollTop);
  //   }
  // }

  if (!to.matched.some((record) => record.meta.guestsOnly)) {
    store.dispatch("auth/noLongerJustLoggedIn");
  }

  // redirect to login if requires login & user not logged in
  if (to.matched.some((record) => record.meta.requiresAuth) && !isLoggedIn) {
    next({
      path: "/login",
      params: { nextUrl: to.fullPath },
    });
  }

  // login and signup page only shows for guests
  if (to.matched.some((record) => record.meta.guestsOnly) && isLoggedIn) {
    next({
      path: "/feed",
      params: { nextUrl: to.fullPath },
    });
  }

  next();
});

const DEFAULT_TITLE = "Sniffing out the merch...";
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
